import { Collaborators } from '../../common/types';

export const sendThirdPartyNudge = async (
	featureVisitedCount: number,
	collaboratorsWithJiraAccess: Collaborators,
	accessCapability: 'DIRECT_ACCESS' | 'REQUEST_ACCESS',
) => {
	const data = {
		featureVisitedCount,
		collaborators: collaboratorsWithJiraAccess.map((c) => c.id),
		accessCapability,
	};
	const response = await fetch(
		'/gateway/api/pi-gateway/webhooks/frontend/confluence/cross-join-third-party-nudge',
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		},
	);

	return await response.json();
};
